import { ArrowDown, Calendar, MapPin, Users } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function AteliersHero({ onSeeDates }) {
  return (
    <section
      data-testid="ateliers-hero"
      className="relative pt-36 pb-24 md:pt-44 md:pb-32 overflow-hidden bg-[#FAF7F8]"
    >
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <div className="absolute top-0 -right-32 w-[42rem] h-[42rem] rounded-full bg-[#E6D6DF]/40 blur-[120px]" />
        <div className="absolute -bottom-32 -left-20 w-[36rem] h-[36rem] rounded-full bg-[#3A2E6E]/8 blur-[120px]" />
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/70 backdrop-blur border border-[#DDD7E2] text-xs uppercase tracking-[0.22em] text-[#3A2E6E]">
            <span className="w-1.5 h-1.5 rounded-full bg-[#C98FA3]" />
            Atelier · Travail en groupe
          </span>
        </Reveal>

        <Reveal delay={0.1}>
          <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-[5.5rem] font-light leading-[1.02] tracking-tight mt-8 text-[#1E1E2A]">
            Constellations familiales
            <br />
            <span className="italic text-[#3A2E6E]">en groupe</span>
          </h1>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="mt-8 text-xl md:text-2xl font-serif-display text-[#3A2E6E] leading-snug max-w-3xl mx-auto">
            Révéler ce qui se joue et transformer ce qui vous freine.
          </p>
        </Reveal>

        <Reveal delay={0.28}>
          <div className="mt-8 max-w-2xl mx-auto space-y-4 text-base md:text-lg text-[#5F6170] leading-relaxed">
            <p>
              Certaines situations se répètent sans que vous en compreniez l'origine.
            </p>
            <p>
              Le travail en groupe permet de mettre en lumière des dynamiques invisibles
              et d'en comprendre les mécanismes.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.38}>
          <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={onSeeDates}
              data-testid="ateliers-hero-cta"
              className="group bg-[#2847B8] text-white hover:bg-[#3A2E6E] transition-all duration-300 rounded-full px-8 py-4 font-medium inline-flex items-center justify-center gap-2"
            >
              Voir les prochaines dates
              <ArrowDown className="w-4 h-4 group-hover:translate-y-1 transition-transform" />
            </button>
          </div>
        </Reveal>

        <Reveal delay={0.5}>
          <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
            {[
              { icon: Calendar, label: "1 journée intensive" },
              { icon: MapPin, label: "Valromey sur Séran" },
              { icon: Users, label: "Groupe restreint" },
            ].map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="flex items-center justify-center gap-2 py-3 px-4 rounded-full bg-white/70 backdrop-blur border border-[#DDD7E2] text-sm text-[#5F6170]"
              >
                <Icon className="w-4 h-4 text-[#C98FA3]" />
                {label}
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
